<template>
  <div>
    <h5 class="content-block">Riwayat Keluarga</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          class="dx-card wide-card"
          id="dataGrid"
          :data-source="dataSource"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          @exporting="onExporting"
        >
          <dx-paging :page-size="10" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem location="after" template="button-template" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template>
          <dx-column
            data-field="pegawai.nama"
            caption="Pegawai"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
          />

          <dx-column
            data-field="nama"
            caption="Nama Anggota Keluarga"
            :allow-sorting="true"
          />

          <dx-column
            data-field="keluarga_hub_id"
            caption="Hubungan Keluarga"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="keluargaHubSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>
          <dx-column
            data-field="tempat_lahir"
            caption="Tempat Lahir"
            :allow-sorting="true"
          />
          <dx-column
            data-field="tgl_lahir"
            caption="Tgl lahir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            editor-type="dxDateBox"
          />

          <dx-column data-field="nik" caption="NIK" :allow-sorting="true" />

          <dx-column
            data-field="perkawinan_status_id"
            caption="Status Pernikahan"
          >
            <DxLookup
              :data-source="perkawinanStatusSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>

          <dx-column data-field="jenis_kelamin" caption="Jenis kelamin">
            <DxLookup :data-source="jenisKelaminSource" />
          </dx-column>

          <dx-column data-field="" caption="Pekerjaan" :allow-sorting="true" />
          <dx-column
            data-field="agama_id"
            caption="Agama"
            :allow-sorting="true"
          >
            <DxLookup
              :data-source="agamaSource"
              value-expr="id"
              display-expr="nama"
            />
          </dx-column>
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            caption=" "
            :allow-exporting="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>

          <!-- <template #cabang-cell-template="{ data }">
            {{ getCabang(data.value) }}
          </template> -->
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
/* eslint-disable */
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxButton,
  DxToolbar,
  DxItem,
  DxLookup,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

// const cabangDataSource = new DataSource({
//   store: cabangStore,
// });

const options = ["Detail", "Transfer", "Resign", "Delete"];

const ds = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: "http://127.0.0.1/odata/Keluargas",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  }),
  expand: ["pegawai"],
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,

    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxButton,
    DxDropDownButton,
    DxExport,
    // DxSelection,
    DxToolbar,
    DxLookup,
    DxItem,
  },
  data() {
    return {
      serverUrl: "http://127.0.0.1/",
      ds,
      events: [],
      jenisKelaminSource: ["L", "P"],
      dataSource: ds,
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      options: options,
      router: router,
    };
  },
  methods: {
    getCabang(index) {
      // console.log(index);
      // console.log(cabangStore)
      //  const coba = _.find(this.cabangs, { id: index });
      // return coba.nama;
    },
    dataEx() {
      console.log(this.pegawaiDataSource);
    },
    importClick() {
      this.router.push({
        name: "practice-sheetjs",
        query: { table: "pegawai" },
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log(e.element.id);
      let pegawaiId = e.element.id;
      notify(e.itemData.name || e.itemData, "success", 600);
      this.router.push({
        name: "navigation-menu-edit",
        query: { id: pegawaiId },
      }); //?id=1
      // this.router.push({ name: "tab-treeview", params: { id: pegawaiId } }); //id tak terlihat di url
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Riwayat Keluarga Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};

const cabangs = [
  { id: 1, nama: "Pusat" },
  { id: 2, nama: "Gerokgak" },
  { id: 3, nama: "Busungbiu" },
  { id: 4, nama: "Seririt" },
  { id: 5, nama: "Lovina" },
  { id: 6, nama: "Kubutambahan" },
  { id: 7, nama: "Sambirenteng" },
];

// const bagians = [
//   { name: "Litbang", value: "Litbang" },
//   { name: "Produksi", value: "Produksi" },
//   { name: "Distribusi", value: "Distribusi" },
//   { name: "Akuntansi", value: "Akuntansi" },
//   { name: "Keuangan", value: "Keuangan" },
//   { name: "Personalia", value: "Personalia" },
// ];

// const subBagians = [{ name: "TI", value: "TI" }];

// const jabatans = [
//   { name: "Kabag", value: "Kabag" },
//   { name: "Kasubag", value: "Kasubag" },
//   { name: "Staf", value: "Staf" },
//   { name: "Direktur Utama", value: "Direktur Utama" },
// ];

// const golongans = [
//   { name: "A1", value: "A1" },
//   { name: "B1", value: "B1" },
//   { name: "C1", value: "C1" },
// ];

// const statuss = [
//   { name: "Pegawai Tetap", value: "Pegawai Tetap" },
//   { name: "Calon Pegawai", value: "Calon Pegawai" },
//   { name: "Kontrak", value: "Kontrak" },
//   { name: "Training", value: "Training" },
// ];

// const agamas = [
//   { name: "Hindu", value: "Hindu" },
//   { name: "Islam", value: "Islam" },
//   { name: "Buddha", value: "Buddha" },
// ];
</script>

<style>
/* .dx-datagrid-headers {
  background-color: red !important;
}
.dx-datagrid-headers {
  background-color: red !important;
} */
</style>
